const moment = require("moment");
const tomorrowDate = moment().add(10, "day").format("DD/MM/YYYY");

export const AIRPORT_CODES = {
    JFK: {
        code: "JFK",
        name: "John F. Kennedy International Airport",
        city: "New York, USA"
    },
    LHR: {
        code: "LHR",
        name: "Heathrow Airport",
        city: "London, UK"
    },
    CDG: {
        code: "CDG",
        name: "Charles de Gaulle Airport",
        city: "Paris, France"
    },
    HND: {
        code: "HND",
        name: "Haneda Airport",
        city: "Tokyo, Japan"
    },
    DXB: {
        code: "DXB",
        name: "Dubai International Airport",
        city: "Dubai, UAE"
    },
    SYD: {
        code: "SYD",
        name: "Sydney Kingsford Smith Airport",
        city: "Sydney, Australia"
    },
    SIN: {
        code: "SIN",
        name: "Changi Airport",
        city: "Singapore"
    },
    FRA: {
        code: "FRA",
        name: "Frankfurt Airport",
        city: "Frankfurt, Germany"
    },
    GRU: {
        code: "GRU",
        name: "São Paulo/Guarulhos International Airport",
        city: "São Paulo, Brazil"
    },
    ATH: {
        code: "ATH",
        name: "Athens International Airport",
        city: "Athens, Greece"
    },
    MVD: {
        code: "MVD",
        name: "Carrasco International Airport",
        city: "Montevideo, Uruguay"
    },
    NRT: {
        code: "NRT",
        name: "Narita International Airport",
        city: "Tokyo, Japan"
    },
    LIM: {
        code: "LIM",
        name: "Jorge Chávez International Airport",
        city: "Lima, Peru"
    }
};

const destinations = [
    {
        id: 1,
        originCode: "JFK",
        destinationCode: "ATH",
        country: "GREECE",
        name: "Athens - Greece",
        cost: 650,
        tomorrowDate
    },
    {
        id: 2,
        originCode: "LHR",
        destinationCode: "MVD",
        country: "uruguay",
        name: "Montevideo - Uruguay",
        cost: 300,
        tomorrowDate
    },
    {
        id: 3,
        originCode: "CDG",
        destinationCode: "NRT",
        country: "JAPAN",
        name: "Tokyo - Japan",
        cost: 1100,
        tomorrowDate
    },
    {
        id: 4,
        originCode: "DXB",
        destinationCode: "LIM",
        country: "PERU",
        name: "Lima - Peru",
        cost: 1400,
        tomorrowDate
    }
];

export { destinations };